// generateMembershipID.js

/**
 * Generate a unique membership ID in format KOS000
 * @param {string} prefix - Prefix for the ID (e.g., 'KOS')
 * @param {number} userNumber - User number
 * @returns {string} - Generated membership ID
 */
export const generateMembershipID = (prefix = 'KOS', userNumber) => {
  const paddedNumber = String(userNumber).padStart(3, '0');
  return `${prefix}${paddedNumber}`;
};

/**
 * Validate membership ID format
 * @param {string} membershipID - Membership ID to validate
 * @returns {boolean} - Whether the ID is valid
 */
export const validateMembershipID = (membershipID) => {
  const pattern = /^[A-Z]+\d{3}$/;
  return pattern.test(membershipID);
};

/**
 * Generate QR code data for membership
 * @param {object} userData - User data object
 * @returns {string} - QR code data string
 */
export const generateQRCodeData = (userData) => {
  return JSON.stringify({
    id: userData.membershipID,
    name: userData.name,
    email: userData.email,
    timestamp: Date.now(),
  });
};
